import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/promos-offer/advertisement')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
